import { useCallback } from 'react';
import { useQueryParam } from './useQueryParam';
import { useHistory } from 'react-router-dom';
import { AuthenticatedRoutes } from '../routers/AuthenticatedRoutes';
import { useZendeskRedirect } from './useZendeskRedirect';

export const useRedirectAfterAuth = () => {
  const redirect = useQueryParam('redirect');
  const return_to = useQueryParam('return_to');
  const history = useHistory();

  const performZendeskRedirect = useZendeskRedirect();

  return useCallback(() => {
    if (return_to) {
      performZendeskRedirect(return_to).then();
    } else if (redirect) {
      history.replace(redirect);
    } else {
      history.replace(AuthenticatedRoutes.ChooseOrganization());
    }
  }, [redirect, return_to, performZendeskRedirect]);
};
